/* eslint-disable promise/prefer-await-to-callbacks */
import axios, { AxiosInstance } from 'axios';
import injectAuthorization from './injectAuthorization';
import injectUnauthorizedLogout from './injectUnauthorizedLogout';
import injectDefaultHeaders from './injectDefaultHeaders';

/**
 * The default network client used by processRequest
 */
const NetworkClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

NetworkClient.interceptors.request.use(injectDefaultHeaders);
NetworkClient.interceptors.request.use(injectAuthorization);
NetworkClient.interceptors.response.use(
  (response) => response,
  (error) => {
    injectUnauthorizedLogout(error);

    // Rethrow error, so that processRequest can catch what the server responds;
    throw error;
  },
);

export default NetworkClient;
